import React from 'react';
import { FunctionColor, Preset, Text } from '@lux/text';
import { Translate, TranslateScope } from '@pegasus/translation';
import { TextLink } from '@lux/text-link';
export var ErrorCard = function () {
    var handleRefreshPage = function () {
        window.location.reload();
    };
    return (React.createElement(TranslateScope, { path: "errors.generic.standardCarousel" },
        React.createElement("div", { className: "bg-function-0 flex h-full w-full items-center justify-center" },
            React.createElement("div", { className: "p-m sm:m-l m-0 max-w-full text-center sm:max-w-[320px]" },
                React.createElement(Text, { className: "m-0 block", preset: Preset.XXL, bold: true, color: FunctionColor.function100 },
                    React.createElement(Translate, { message: "headline" })),
                React.createElement(Text, { className: "py-m block", preset: Preset.M, color: FunctionColor.function100 },
                    React.createElement(Translate, { message: "message" })),
                React.createElement(TextLink, { preset: Preset.L, bold: true, uppercase: true, onClick: handleRefreshPage }, "Try again")))));
};
